export default __webpack_public_path__ + "static/side-menu-btn-android-2827c4cb5bb6e5b657b9805942c8f506.png";